"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _vue = _interopRequireDefault(require("vue"));

var _vuex = _interopRequireDefault(require("vuex"));

var _getters = _interopRequireDefault(require("./getters"));

var _app = _interopRequireDefault(require("./modules/app"));

var _operate = _interopRequireDefault(require("./modules/operate"));

_vue["default"].use(_vuex["default"]);

var store = new _vuex["default"].Store({
  modules: {
    app: _app["default"],
    operate: _operate["default"]
  },
  getters: (0, _objectSpread2["default"])({}, _getters["default"])
});
var _default = store;
exports["default"] = _default;